import { render, staticRenderFns } from "./check-box-preview.vue?vue&type=template&id=1236c576&scoped=true&"
import script from "./check-box-preview.vue?vue&type=script&lang=js&"
export * from "./check-box-preview.vue?vue&type=script&lang=js&"
import style0 from "./check-box-preview.vue?vue&type=style&index=0&id=1236c576&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236c576",
  null
  
)

component.options.__file = "check-box-preview.vue"
export default component.exports